'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import LegacyProfileFillIcon from 'src/app/_components/icons/legacy/LegacyProfileFillIcon';
import { useCurrentPath } from 'src/hooks/useCurrentPath';
import { useAppSelector } from 'src/store/client/config';

import HeaderLogo from './Logo';
import MenuDrawer from './MenuDrawer';
import MenuButton from './MenuDrawer/MenuButton';

const Header = () => {
  const currentPath = useCurrentPath();
  const pathname = usePathname();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const prevPathnameRef = useRef(pathname);

  const { LoggedIn: isLoggedIn } = useAppSelector((state) => state.user);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // 1. 오픈시 스크롤 막기
  useEffect(() => {
    const html_selector = document.querySelector('html') as HTMLHtmlElement;
    const body_selector = document.querySelector('body') as HTMLBodyElement;

    if (isMenuOpen) {
      html_selector.style.overflow = 'hidden';
      body_selector.style.overflow = 'hidden';
    } else {
      html_selector.style.overflow = 'auto';
      body_selector.style.overflow = 'auto';
    }
  }, [isMenuOpen]);

  // 2. 라우터 이동시 닫기
  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      prevPathnameRef.current = pathname;
      requestAnimationFrame(() => {
        setIsMenuOpen(false);
      });
    }
  }, [pathname]);

  return (
    <header className="fixed top-0 right-0 left-0 z-[201] mx-auto w-full max-w-[480px] border-r border-l border-g-90 bg-white max-md:border-x-0">
      <nav className="flex h-[56px] flex-row items-center justify-between border-b border-[#D6D6D6]">
        <div className="relative mx-auto flex h-full w-full max-w-[1280px] flex-row items-center justify-between px-3 py-2">
          <div className="flex flex-row items-center">
            <HeaderLogo />
          </div>
          <div className="flex flex-row items-center">
            <div className="flex flex-row items-center gap-1">
              {!isLoggedIn && (
                <Link
                  href={{ pathname: '/account/login', query: { retUrl: currentPath } }}
                  className="flex p-[5px] hover:cursor-pointer hover:opacity-80"
                  aria-label="로그인 페이지로 이동"
                >
                  <LegacyProfileFillIcon size={30} />
                </Link>
              )}
            </div>
            <MenuButton isOpen={isMenuOpen} onClick={toggleMenu} />
          </div>
        </div>
      </nav>
      <MenuDrawer isOpen={isMenuOpen} />
    </header>
  );
};

export default Header;
